import { calculateScheduledWorkDay } from './calculate-scheduled-work-day';
import type { WorkDayWithException } from '../../../pages/staffing-page/work-day-with-exception';

export function calculateActualWorkDay(employee, day, workScheduleException): WorkDayWithException {
  const exception = workScheduleException || employee.workScheduleExceptions.find((e) => e.date === day);
  if (exception !== undefined) {
    if (exception.work) {
      return {
        workDay: true,
        start: exception.start || '00:00',
        end: exception.end || '00:00',
        exception: true,
      };
    } else {
      return { workDay: false, exception: true };
    }
  } else {
    return {
      ...calculateScheduledWorkDay(employee.workSchedules, day),
      exception: false,
    };
  }
}
